
export default {
    props: {
        machineTypes: {
            type:  Array,
            default:  () => []
        }
    },
}
